"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var withWorkRequest_1 = require("./withWorkRequest");
Object.defineProperty(exports, "withWorkRequest", { enumerable: true, get: function () { return withWorkRequest_1.default; } });
//# sourceMappingURL=index.js.map